__turbopack_context__.v({
  "shows_landing_error": "SearchLandingError-module-scss-module__-SEQSa__shows_landing_error",
  "shows_landing_error_header": "SearchLandingError-module-scss-module__-SEQSa__shows_landing_error_header",
  "shows_landing_error_small": "SearchLandingError-module-scss-module__-SEQSa__shows_landing_error_small",
});
